import { Image as ImageProps } from 'src/types/Image';
import Image from 'next/image';
import classNames from 'classnames';
import { PrismicNextImage, PrismicNextImageProps } from '@prismicio/next';
import React from 'react';
export interface CardGenericProps {
    className?: string;
    image: ImageProps & {
        split?: ImageProps[];
        raw?: boolean;
        field?: PrismicNextImageProps['field'];
    };
    children?: React.ReactNode;
    sectionClassName?: string;
}

const CardGeneric = ({
    className,
    image,
    sectionClassName,
    children,
}: CardGenericProps) => {
    const splitClass = 'h-full w-1/2 rounded-none object-cover object-center';
    const imageClass = '"max-h-full w-full rounded-lg object-cover';
    return (
        <article
            className={classNames(
                'relative flex h-full flex-col overflow-hidden rounded-2xl border border-grey-200 bg-white',
                className,
            )}
        >
            <header
                className={classNames(
                    'mb-2 w-full overflow-hidden',
                    image.split && 'mb-0',
                )}
                style={{ aspectRatio: '704 / 406' }}
            >
                {image.split ? (
                    <picture className="flex h-full min-h-[200px] flex-nowrap">
                        {image.split.map((img, index) =>
                            image.raw ? (
                                <img
                                    className={splitClass}
                                    {...img}
                                    key={index}
                                    alt={image.alt}
                                />
                            ) : (
                                <Image
                                    className={splitClass}
                                    {...img}
                                    key={index}
                                    alt={image.alt}
                                />
                            ),
                        )}
                    </picture>
                ) : image.raw ? (
                    <img className={imageClass} {...image} alt={image.alt} />
                ) : image.field ? (
                    <PrismicNextImage
                        className={imageClass}
                        field={image.field}
                        width={image.width}
                        height={image.height}
                    />
                ) : (
                    <Image className={imageClass} {...image} alt={image.alt} />
                )}
            </header>
            <section className={classNames(sectionClassName, 'flex-1')}>
                {children ? children : null}
            </section>
        </article>
    );
};

export default CardGeneric;
